import { LinesInterfaceState, initialLinesState } from '../state/lines.state';
import { LinesActions, ELinesActions } from '../actions/lines.actions';

export function linesReducer(state: LinesInterfaceState = initialLinesState, action: LinesActions): LinesInterfaceState {
  switch (action.type) {
    case ELinesActions.GetLinesSuccess: {
      return { ...state, lines: action.payload };
    }

    default:
      return state;
  }
};
